// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__mpp5g","title":"PageHeader_title__46e09","lead":"PageHeader_lead__h6oy9"};